//#region src/utils/tables.ts
var e = {
	1: "large-12",
	2: "large-6",
	3: "large-4",
	4: "large-3"
}, t = {
	1: "small-12",
	2: "small-12",
	3: "small-12",
	4: "small-6"
};
function n(n) {
	return !n || n > 4 ? "" : `${e[n] ?? ""} ${t[n] ?? ""} columns`;
}
//#endregion
export { n as getResponsiveClasses };
